import { render, staticRenderFns } from "./applyPaper.vue?vue&type=template&id=501064db"
import script from "./applyPaper.vue?vue&type=script&lang=js"
export * from "./applyPaper.vue?vue&type=script&lang=js"
import style0 from "./applyPaper.vue?vue&type=style&index=0&id=501064db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports